
const InvestmentCardLoadingSkeleton = () => {
  return (
    <div className="tw-flex-1 tw-pt-6 max-sm:tw-pt-2 tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-between">
      <div className="tw-flex tw-w-full tw-justify-between max-sm:tw-flex-col">
        <div className='tw-w-[60%] tw-flex tw-flex-col tw-gap-1 max-sm:tw-flex-row max-sm:tw-w-[100%] max-sm:tw-justify-between max-sm:tw-mb-1'>
          <div className='skeleton-block tw-w-[90%] tw-overflow-hidden max-sm:tw-w-[60%] tw-text-xs'>Label</div>
          <div className='skeleton-block tw-w-[80%] tw-overflow-hidden max-sm:tw-w-[30%]'>Value</div>
        </div>
      </div>
      <div className="tw-flex tw-w-full tw-justify-between max-sm:tw-flex-col">
        <div className='tw-w-[50%] tw-flex tw-flex-col tw-gap-1 max-sm:tw-flex-row max-sm:tw-w-[100%] max-sm:tw-justify-between max-sm:tw-mb-1'>
          <div className='skeleton-block tw-w-[90%] tw-overflow-hidden max-sm:tw-w-[35%] tw-text-xs'>Label</div>
          <div className='skeleton-block tw-w-[50%] tw-overflow-hidden max-sm:tw-w-[20%]'>Value</div>
        </div>
        <div className='tw-w-[50%] tw-flex tw-flex-col tw-gap-1 tw-items-end max-sm:tw-flex-row max-sm:tw-w-[100%] max-sm:tw-justify-between max-sm:tw-mb-1'>
          <div className='skeleton-block tw-w-[30%] tw-overflow-hidden max-sm:tw-w-[30%] tw-text-xs'>Label</div>
          <div className='skeleton-block tw-w-[50%] tw-overflow-hidden max-sm:tw-w-[15%]'>Value</div>
        </div>
      </div>
    </div>
  )
}

export default InvestmentCardLoadingSkeleton